































import { Component, Vue } from "vue-property-decorator";
import { Owner } from "@/api/owner/types";
import OwnerSelect from "@/components/ownerSelect/OwnerSelect.vue";
import { SentinelaReportRequest } from '@/api/report/types';
import * as reportService from '@/services/report';
import { getProducts } from "@/api/products";
import { AvailabilityDTO } from "@/api/products/types";


@Component({
  name: "SentinelaReport",
  components: {
    OwnerSelect
  }
})

export default class SentinelaReport extends Vue {
  
  private cropTypeOption = ["SOY", "CORN"];
  private selectedOwner: Owner | null = null;
  private selectedCropType: string = 'SOY';
  private products: AvailabilityDTO[] = [];
  private loading = false;
  private currentYear: number = (new Date()).getFullYear()


  private async beforeMount() {
    this.loading = true
    try {
      this.products = (await getProducts()).data;
      this.currentYear = this.products.find(v => (v.cropType === this.selectedCropType && v.analysisType === 'SENTINELA'))?.years[0] ?? (new Date().getFullYear());
    } finally {
      this.loading = false
    }
  }

  private get isAdminUser() {
    return this.$store.getters['user/isAdminUser'];
  }

  get availableYears() {
    const baseYear = this.products.find(v => (v.cropType === this.selectedCropType && v.analysisType === 'SENTINELA'))?.years[0] ?? (new Date().getFullYear());
    return [baseYear, baseYear - 1, baseYear - 2]
  }

  private async requestSentinelaReport() {
    const request = new SentinelaReportRequest();
    request.cropType = this.selectedCropType;
    request.monitoringYear = this.currentYear;
    request.ownerId = this.selectedOwner?.uuid ?? null;

    await reportService.downloadSentinelaReport(request)
  }

}
